import React from 'react'
import mockup from '../../assets/mockup.png'
import './Download.css'

export default function Download() {
  return (
    <section className='download-section' id='download'>
        <div className="container">
            <div className="download-inner">
                <div className="download-left">
                    <h1 className='download-left-title'>Commit to a better you</h1>
                    <p className='download-left-text'>Download Commito now and <span>take the first step toward better hydration.</span></p>
                    <a className='download-left-button' href="https://apps.apple.com/us/app/commito/id6642675101" target='_blank' rel="noreferrer">
                        Download For Free
                    </a>
                </div>
                <div className="download-right">
                    <img src={mockup} alt="" />
                </div>
            </div>
        </div>
    </section>
  )
}
